import React from 'react';
import PropTypes from 'prop-types';
import CheckboxAttribute from '../../CheckBoxAttribute';

const Assigner = (props) => (
  <div className="p-2">
    <CheckboxAttribute
      onCheckBoxChange={props.onBranchAssignment}
      value={props.checked}
      keyPath={props.keyPath}
    >
      Assign to <span className="font-weight-bold">Branch {props.branchId}</span> (when <span className="code">{props.branchingFieldName}</span> is <span className="code">{props.fieldValue}</span> )
    </CheckboxAttribute>
  </div>
);
export default Assigner;

Assigner.propTypes = {
  branchingFieldName: PropTypes.string.isRequired,
  branchId: PropTypes.number.isRequired,
  checked: PropTypes.bool.isRequired,
  fieldValue: PropTypes.string.isRequired,
  keyPath: PropTypes.array.isRequired,
  onBranchAssignment: PropTypes.func.isRequired,
};
